// Аналитика активности пользователей.
// Используется бэкендом (приём событий + выдача в админку),
// Mini App (отправка событий) и админкой (отображение).
// Типы событий активности — соответствуют enum ActivityType в Prisma.
export const ACTIVITY_TYPES = [
    "BOT_START", // нажал /start в боте
    "APP_OPEN", // открыл Mini App
    "SECTION_VIEW", // открыл раздел Mini App
    "FORM_START", // начал заполнять анкету (первый ввод)
    "EXTERNAL_LINK", // кликнул по внешней ссылке (Instagram, RESIDE, FinKeeper…)
];
// Какие события Mini App имеет право отправлять (BOT_START пишет только сам бот).
export const MINI_APP_EVENT_TYPES = [
    "APP_OPEN",
    "SECTION_VIEW",
    "FORM_START",
    "EXTERNAL_LINK",
];
export const activityTypeLabels = {
    BOT_START: "Запустил бота",
    APP_OPEN: "Открыл приложение",
    SECTION_VIEW: "Открыл раздел",
    FORM_START: "Начал заполнять анкету",
    EXTERNAL_LINK: "Перешёл по ссылке",
};
// Человекочитаемые названия разделов Mini App по пути роута.
// Mini App присылает pathname в поле label события SECTION_VIEW,
// админка показывает уже название.
export const sectionLabelByPath = {
    "/": "Главное меню",
    "/advisory-board": "💼 Advisory Board",
    "/event-consulting": "🎤 Консалтинг по мероприятиям",
    "/marketing": "📈 Маркетинг (меню)",
    "/marketing/consultation": "📈 Маркетинг — разовая консультация",
    "/marketing/strategy": "📈 Маркетинг — стратегия",
    "/time-management": "🕘 Тайм-менеджмент «Как у Антона»",
    "/automation": "🤖 Автоматизация бизнеса",
    "/finkeeper": "💰 FinKeeper",
    "/bali": "🏝 Недвижимость на Бали (меню)",
    "/bali/reside": "🏝 RESIDE — инвестиции",
    "/bali/villa-rent": "🏖 Аренда виллы",
    "/bali/cocoon": "🌿 Cocoon Resort — акционерство",
    "/instagram-ads": "📣 Реклама в Instagram",
    "/partnership": "🤝 Партнёрство",
    "/about": "👤 Обо мне / Проекты",
    "/links": "🔗 Соцсети и ссылки",
};
export function sectionLabel(path) {
    if (!path)
        return "—";
    return sectionLabelByPath[path] ?? path;
}
// Пути-анкеты Mini App → тип заявки. Нужно, чтобы понять, какой именно
// анкеты человек начал заполнять (FORM_START) и сопоставить с заявкой.
export const formTypeByPath = {
    "/advisory-board": "ADVISORY_BOARD",
    "/event-consulting": "EVENT_CONSULTING",
    "/marketing/consultation": "MARKETING_CONSULTATION",
    "/marketing/strategy": "MARKETING_STRATEGY",
    "/time-management": "TIME_MANAGEMENT",
    "/automation": "AUTOMATION",
    "/bali/reside": "RESIDE_INVESTMENT",
    "/bali/villa-rent": "VILLA_RENT",
    "/bali/cocoon": "COCOON_INVESTMENT",
    "/instagram-ads": "INSTAGRAM_ADS",
    "/partnership": "PARTNERSHIP",
};
// Является ли путь анкетой (есть форма заявки).
export function isFormPath(path) {
    return !!path && path in formTypeByPath;
}
//# sourceMappingURL=activity.js.map